import { TreeMultiCombobox } from 'src/shared/entities/control-entities/treemulticombobox.entity';
import type { Directories } from 'src/store/directories/directories.store';

import type { TTreeMultiCombobox } from '../../types';

type TMulticomboboxSerializerOptions = {
  item: TTreeMultiCombobox;
  directories: Directories;
};

export const mapTreeMultiCombobox = ({ item, directories }: TMulticomboboxSerializerOptions): TreeMultiCombobox => {
  const data = {
    directories,
    formElementRefId: item.attrName,
    fieldId: item.fieldId,
    required: !!item.required,
    enableIf: item.enableIf,
    updateDictValue: item.updateDictValue,
    checkDictValue: item.checkDictValue,
    computeTags: item.computeTags,
    additionalConditionalAttributes: item.additionalConditionalAttributes,
    calculatedValue: item.calculatedValue,
    refObjectAttr: item.refObjectAttr,
    refObjectType: item.refObjectType,
    restrictions: { required: !!item.required },
    directory: directories.getObject(item.refObjectType),
    refRest: 'refRest' in item ? item.refRest : undefined,
    label: directories.getFieldLabel(item.fieldId) || undefined,
    placeholder: directories.getFieldPlaceholder(item.fieldId) || undefined,
    settings: item.settings,
  };

  return new TreeMultiCombobox(data);
};
